export default "__VITE_ASSET__c55fe071__"